import PeopleProfessionalHeader from './PeopleProfessionalHeader';

export { type PeopleProfessionalHeaderProps } from './PeopleProfessionalHeader';
export default PeopleProfessionalHeader;
